<template>
  <div id="report" style="height:100%;">
    <div class="table_searchbar">
      <el-row>
        <el-col :span="W?5:7">
          <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">处理状态：</span>
            <el-select
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              clearable
              v-model="searchForm.exceptionStatus"
              size="small"
              maxlength="16"
              placeholder="处理状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="W?5:7">
          <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">订单号：</span>
            <el-input
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              size="small"
              v-model="searchForm.orderCode"
              maxlength="100"
              placeholder="订单号"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="W?5:6">
          <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">物料编码：</span>
            <el-input
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              size="small"
              v-model="searchForm.materialCode"
              maxlength="100"
              placeholder="物料编码"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px">
        <el-col :span="W?5:7">
          <div class @keydown.enter="clickSearch(1,'setpage')">
            <span class="title">异常类型：</span>
            <el-select
              :style="W?{'max-width':'180px'}:{'max-width':'160px'}"
              clearable
              v-model="searchForm.exceptionType"
              size="small"
              maxlength="16"
              placeholder="异常类型"
            >
              <el-option
                v-for="item in exceptionTypeOptions"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="W?19:17">
          <div style="text-align:right">
            <el-button
              icon="el-icon-search"
              size="mini"
              type="primary"
              @click="clickSearch(1,'setpage')"
            >查询</el-button>
            <el-button
              style="margin-left: 9px;"
              icon="el-icon-refresh"
              size="mini"
              @click="clearSearch"
            >重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="tab">
      <el-row class="table-wrap" style="margin-top:10px">
        <!--  -->
        <div style="margin-top:10px;">
          <el-table :data="orderList" class="table_data y_Public_table">
            <el-table-column prop="materialName" label="物料名称">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.materialName"
                  placement="top-start"
                >
                  <div class="y_clamp">
                    <div>{{scope.row.materialName}}</div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="materialCode" label="物料编码"></el-table-column>
            <el-table-column prop="materialModel" label="物料型号"></el-table-column>
            <el-table-column prop="exceptionType" label="异常类型" :formatter="parseExceptionType"></el-table-column>
            <el-table-column prop="orderCode" label="关联订单号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="warningTime" label="预警时间" :formatter="parseOrderDate"></el-table-column>
            <el-table-column
              prop="exceptionStatus"
              label="状态"
              :formatter="parseStatus"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  :style="scope.row.exceptionStatus==0 || scope.row.exceptionStatus==2?{color:'red'}:{}"
                >{{parseStatus(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="showDetail(scope.row)" type="text" size="small">查看详情</el-button>
                <el-button
                  v-if="scope.row.exceptionStatus==0"
                  @click="dispose(scope.row, 2)"
                  type="text"
                  size="small"
                >开始处理</el-button>
                <el-button
                  v-if="scope.row.exceptionStatus==2"
                  @click="dispose(scope.row, 1)"
                  type="text"
                  size="small"
                >完成处理</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-row>
      <div class="page" v-if="page.isShow">
        <div class="total_page">
          <span>共{{page.total}}条 10条/页</span>
        </div>
        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="page.total"
            @current-change="pageChange"
            :current-page="page.tableCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </el-row>

    <!-- 查看详情开始 -->
    <el-dialog
      :title="this.addForm.title"
      @close="cancelViewDialog"
      :visible.sync="viewDialogVisible"
      :width="span==5?'50%':'68%'"
      center
      :close-on-click-modal="false"
    >
      <el-row :gutter="20" style="margin-bottom:20px">
        <el-col :span="8">
          <span class="title">物料名称：</span>
          <span>{{addForm.materialName}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">物料编码：</span>
          <span>{{addForm.materialCode}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">物料型号：</span>
          <span>{{addForm.materialModel}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" :style="addForm.exceptionType==2?{marginBottom:'20px'}:{}">
        <el-col :span="8">
          <span class="title">异常状态：</span>
          <span>{{addForm.exceptionStatus}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">关联订单：</span>
          <span>{{addForm.orderCode}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">预警时间：</span>
          <span>{{addForm.warningTime}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="addForm.exceptionType==2" style="margin-bottom:20px">
        <el-col :span="8">
          <span class="title">工序名称：</span>
          <span>{{addForm.procedureName}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">设备编号：</span>
          <span>{{addForm.deviceCode}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">生产部门：</span>
          <span>{{addForm.organizationName}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="addForm.exceptionType==2">
        <el-col :span="8">
          <span class="title">执行人：</span>
          <span>{{addForm.workerName}}</span>
        </el-col>
        <el-col :span="8">
          <span class="title">预定节拍：</span>
          <span>{{addForm.cycle}} 秒</span>
        </el-col>
        <el-col :span="8">
          <span class="title">实际节拍：</span>
          <span>{{addForm.actualCycle}} 秒</span>
        </el-col>
      </el-row>
      <span slot="footer" style="margin-top:-10px">
        <el-button
          v-if="addForm.exceptionStatus=='未处理'"
          @click="dispose(addForm, 2)"
          type="primary"
        >开始处理</el-button>
        <el-button
          v-if="addForm.exceptionStatus=='处理中'"
          @click="dispose(addForm, 1)"
          type="primary"
        >完成处理</el-button>
        <el-button @click="cancelViewDialog">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 查看详情结束 -->

    <!-- 生产流转异常详情开始 -->
    <!-- 生产流转异常详情结束 -->
  </div>
</template>

<script>
export default {
  name: "warning",
  data() {
    return {
      YmouserShow: null,
      searchCopy: {},
      viewDialogVisible: false,
      exceptionTypeOptions: [
        { id: 1, label: "生产延期" },
        { id: 2, label: "节拍异常" },
        { id: 3, label: "库存不足" },
        { id: 4, label: "设备异常" },
        { id: 5, label: "工序异常" }
        // {id:3,label:'库存预警'},
        // {id:4,label:'质检超时'},
      ],
      addForm: {},
      fristLoad: false,
      statusOptions: [
        { name: "未处理", id: 0 },
        { name: "已处理", id: 1 },
        { name: "处理中", id: 2 }
      ],
      tableData: [],
      page: {
        isShow: true,
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      W: false,
      searchForm: {
        exceptionStatus: null,
        orderCode: "",
        materialCode: "",
        exceptionType: null
      },
      orderList: [],
      //   生产流转异常详情对话框
      ProDialogVisible: false
    };
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    },
    warningType() {
      if (this.$store.state.warningType == 1) {
        this.$set(this.searchForm, "exceptionType", 2);

        this.search(1);
        this.$store.commit("changeWarningType", 0);
      }
      return this.$store.state.warningType;
    }
  },
  watch: {
    warningType(old, newValue) {
      log(old, newValue, "异常状态改变");
    }
  },
  mounted: function() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.init();
  },
  methods: {
    MmouseOver(ev) {
      console.log(ev);
      let offsetHeight = this.$refs.Mmover.offsetHeight;
      let scrollHeight = this.$refs.Mmover.scrollHeight;
      if (offsetHeight < scrollHeight) {
        this.YmouserShow = ev;
      }
      console.log(offsetHeight);
      console.log(scrollHeight);
    },
    Monmouseout() {
      this.YmouserShow = null;
    },
    init: function() {
      this.search();
    },
    clickSearch: function(paage, type) {
      this.searchCopy = commonUtils.cloneObj(this.searchForm);
      if (type) {
        this.$set(this.page, "tableCurrentPage", 1);
      }
      console.log(this.searchForm);

      this.search(1);
    },
    pageChange(pageNum) {
      this.$set(this, "searchForm", commonUtils.cloneObj(this.searchCopy));
      this.search(pageNum);
    },
    //清空查询条件
    clearSearch() {
      (this.searchForm.exceptionStatus = null),
        (this.searchForm.orderCode = "");
      this.searchForm.materialCode = "";
      this.searchForm.exceptionType = null;
    },
    search: function(pageNum) {
      if (pageNum == null || pageNum instanceof KeyboardEvent) {
        pageNum = 1;
      }
      this.$set(this.page, "tableCurrentPage", pageNum);
      console.log(this.searchForm.exceptionType);
      // 流转异常
      // if (this.searchForm.exceptionType == 3) {
      //   this.$RequestUtil.get({
      //     url: "/api/productionFlow/list",
      //     type: "sync",
      //     params: {
      //       // 异常类型
      //       exceptionType: this.searchForm.exceptionType,
      //       // 页码
      //       pageNum: pageNum,
      //       // 页/条
      //       pageSize: this.page.pageSize,
      //       // 处理状态
      //       isDispose: this.searchForm.exceptionStatus,
      //       // 订单号
      //       orderCode: this.searchForm.orderCode,
      //       // 物料编码
      //       materialCode: this.searchForm.materialCode
      //     },
      //     success: res => {
      //       if (res.code == 0) {
      //         this.tableData = res.data;
      //         this.page.total = res.totalPages;
      //         if (res.totalPages == 0 && this.fristLoad) {
      //           this.$message.warning("查询不到符合条件的数据");
      //         }
      //         this.fristLoad = true;
      //         this.orderList = res.data;
      //         console.log(this.orderList);
      //       } else {
      //         //test
      //         console.log(this.dig);
      //         //
      //         this.$message.error(res.message || res.msg);
      //       }
      //     }
      //   });
      // } else {
        
      // }
      this.$RequestUtil.get({
        url: "/api/exceptionInfo/listExceptionInfoDetailIpc",
        type: "sync",
        params: {
          exceptionType: this.searchForm.exceptionType,
          pageNum: pageNum,
          pageSize: this.page.pageSize,
          exceptionStatus: this.searchForm.exceptionStatus,
          orderCode: this.searchForm.orderCode,
          materialCode: this.searchForm.materialCode
        },
        success: res => {
          if (res.code == 0) {
            this.tableData = res.data;
            this.page.total = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
            this.orderList = res.data;
            console.log(this.orderList);
          } else {
            //test
            console.log(this.dig);
            //
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    dispose(rowData, status) {
      this.$confirm("确定处理该异常?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/exceptionInfo/handleExceptionInfoDetailIpc",
          type: "sync",
          params: {
            id: rowData.id,
            exceptionStatus: status
          },
          success: res => {
            if (res.code != -1) {
              this.$message({
                type: "success",
                message: "处理成功!"
              });
              this.viewDialogVisible = false;
              this.search(this.page.tableCurrentPage);
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          }
        });
      });
    },
    parseOrderDate: function(time) {
      if (time != null) {
        let dateString = commonUtils.timestampToDate(time.warningTime);
        return dateString.substring(0, dateString.length - 3);
      }
    },
    parseStatus: function(row) {
      if (row.exceptionStatus == 0) {
        return "未处理";
      } else if (row.exceptionStatus == 1) {
        return "已处理";
      } else if (row.exceptionStatus == 2) {
        return "处理中";
      } else {
        return "";
      }
    },
    parseExceptionType(row) {
      return (this.exceptionTypeOptions.find(
        item => item.id == row.exceptionType
      )||{}).label;
    },

    parseRatio: function(rowData) {
      if (rowData.productionProcess != null) {
        return rowData.productionProcess + "%";
      }
    },
    showDetail(rowData) {
      this.addForm = commonUtils.cloneObj(rowData);
      this.addForm.title = this.parseExceptionType(rowData);
      this.addForm.warningTime = this.parseOrderDate(rowData);
      this.addForm.exceptionStatus = this.parseStatus(rowData);
      console.log(this.addForm);
      this.viewDialogVisible = true;
    },
    cancelViewDialog() {
      this.viewDialogVisible = false;
    },

    //
    showDig() {
      this.ProDialogVisible = true;
    },
    closeProDialogVisible() {
      this.ProDialogVisible = false;
    },
    //

    changeClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 2) {
        return "red";
      } else {
        return "";
      }
    },
    isStyle({ row, column, rowIndex, columnIndex }) {
      // log(row,row.id,)
      if (row.aptime >= 45 && columnIndex == 4) {
        return {
          backgroundColor: "#EE2C2C",
          color: "black"
        };
      } else if (50 <= row.tztime && row.tztime < 100 && columnIndex == 8) {
        return {
          backgroundColor: "#FFD700",
          color: "black"
        };
      } else if (row.tztime >= 100 && columnIndex == 8) {
        return {
          backgroundColor: "#EE2C2C",
          color: "black"
        };
      }
    },
    isRowStyle({ row, rowIndex }) {
      if (rowIndex >= 0) {
        return {
          lineHeight: ""
        };
      }
    }
    // tiaozhuan() {
    //   this.$router.push("/tiaozhuan");
    // }
  }
};
</script>

<style scoped>
.isRowStyle th {
  height: 30px;
}
.red {
  background-color: red;
}
.el-table-column {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* .warp{
    overflow: hidden;
    height: 100%;
    width: 100%;
    
} */
#report {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  scrollbar-width: none;
}
#report::-webkit-scrollbar {
  display: none;
}
#report .title {
  font-size: 14px;
}
.search-input-row {
  margin-top: 10px;
}
.page {
  display: flex;
  justify-content: flex-end;
}
.total_page {
  margin-top: 16px;
  margin-right: 16px;
  color: #606266;
  font-size: 14px;
}
@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
</style>
<style>
.el-table .el-table__body .rowbg {
  background: #ffffff !important;
}
.el-table .el-table__body .rowbg:hover > td {
  background: #ffffff !important;
}
/*  */
.marTop {
  margin-top: 30px;
}

/* .tabs .el-tabs__item{
    font-size:18px;
    text-align:left;
    width:112px;
}
.tabs .el-tabs__nav{
    width:100%;
    display:flex;
    justify-content: space-around;
}
.tabs .el-tabs__nav-wrap::after{
    height: 0;
}
.tabs .el-tabs__active-bar{
    width:72px;
    height: none;
} */
/* .tabs .el-tabs__nav-wrap::after{
    height: 0;
} */
/* .tabs  .el-tabs__active-bar{
    height: 0px;
}
.tabs  .is-active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #409EFF;
    z-index: 1;

}
.tabs .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
} */
</style>





// WEBPACK FOOTER //
// src/views/WarningIpc.vue